import React from 'react';

import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

import { useProfileState, useProfileActions } from './ProfileContext';

import { updateUserCertification } from './restApi';

const UpdateUserCertificationForm = () => {
  const profileState = useProfileState();
  const { onResponse, onError, updateUserCertificationFormName, updateUserCertificationFormIssuingOrganization, updateUserCertificationFormDateObtained, updateUserCertificationFormExpirationDate, updateUserCertificationFormCredentialId, closeUpdateUserCertificationModal } = useProfileActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    updateUserCertification({
      onResponse,
      onError,
      body: {
        authenticityToken,
        updateUserCertificationForm: profileState?.updateUserCertificationForm,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Name" id="name">
        <Input
          type="text"
          value={profileState?.updateUserCertificationForm?.name || ''}
          onChange={(e) => {
            updateUserCertificationFormName(e.target.value);
          }}
        />
      </Field>

      <Field label="Issuing Organization" id="issuingOrganization">
        <Input
          type="text"
          value={profileState?.updateUserCertificationForm?.issuingOrganization || ''}
          onChange={(e) => {
            updateUserCertificationFormIssuingOrganization(e.target.value);
          }}
        />
      </Field>

      <Field label="Date Obtained" id="dateObtained">
        <Input
          type="date"
          value={profileState?.updateUserCertificationForm?.dateObtained || ''}
          onChange={(e) => {
            updateUserCertificationFormDateObtained(e.target.value);
          }}
        />
      </Field>

      <Field label="Expiration Date" id="expirationDate">
        <Input
          type="date"
          value={profileState?.updateUserCertificationForm?.expirationDate || ''}
          onChange={(e) => {
            updateUserCertificationFormExpirationDate(e.target.value);
          }}
        />
      </Field>

      <Field label="Credential ID" id="credentialId">
        <Input
          type="text"
          value={profileState?.updateUserCertificationForm?.credentialId || ''}
          onChange={(e) => {
            updateUserCertificationFormCredentialId(e.target.value);
          }}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              closeUpdateUserCertificationModal();
            }}
          >
            Cancel
          </Button>
          <Button type="submit">
            Save Your Certification
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default UpdateUserCertificationForm;
